<app-logo-header></app-logo-header>
<div [ngStyle]="dynamicMargin">
  <hr />
  <div class="container mt-3" id="print-section">
    <div class="row">
      <div class="col-md-7 mb-1 align-self-center">
        <h2>{{ 'Buyer.Receipt' | translate }}</h2>
      </div>
      <div class="col-md-5 mb-1 align-self-center">
        <img class="p-2" src="{{data.business.logo}}" alt="Business Logo">
      </div>
    </div>

    <div class="row">
      <div class="col-md-7 mb-1 align-self-center">
        <p><strong>{{ 'Buyer.BusinessName' | translate }}:</strong> {{data.business?.name}}</p>
      </div>
      <div class="col-md-5 mb-1 align-self-center">
        <p><strong>{{ 'Buyer.Date' | translate }}:</strong> {{data.vpihs.date | date:'medium' }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-7 mb-1 align-self-center">
        <p><strong>{{ 'Buyer.BusinessPhone' | translate }}:</strong> {{data.business?.cs_phone}}</p>
      </div>
      <div class="col-md-5 mb-1 align-self-center">
        <p id="refNum"><strong>{{ 'Buyer.ReferenceNumber' | translate }}:</strong> {{data.vpihs.refNum}}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-7 mb-1 align-self-center">
        <p><strong>{{ 'Buyer.BusinessEmail' | translate }}:</strong> {{data.business?.cs_email}}</p>
      </div>
    </div>

    <div class="row">
      <table class="table table-hover">
        <thead class="thead-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">{{ 'Buyer.Item' | translate }}</th>
            <th scope="col">{{ 'Buyer.Quantity' | translate }}</th>
            <th scope="col">{{ 'Buyer.UnitPrice' | translate }}</th>
            <th scope="col">{{ 'Buyer.Amount' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-primary" *ngFor="let item of data.items; index as i">
            <th scope="row">{{i + 1}}</th>
            <td>{{item.name}}</td>
            <td>{{item.quantity}}</td>
            <td>{{item.price | number: '1.2-2' }}  {{data.vpihs.currency}}</td>
            <td>{{item.amount | number: '1.2-2' }} {{data.vpihs.currency}}</td>
          </tr>
          <tr>
            <td colspan="3" class="border-0"></td>
            <td>{{ 'Buyer.Subtotal' | translate }}</td>
            <td>{{data.vpihs.subTotal | number: '1.2-2'}} {{data.vpihs.currency}}</td>
          </tr>
          <tr>
            <td colspan="3" class="border-0"></td>
            <td>{{ 'Buyer.Taxes' | translate }}</td>
            <td>{{(data.vpihs.taxes) | number: '1.2-2'}} {{data.vpihs.currency}}</td>
          </tr>
          <tr>
            <td colspan="3" class="border-0"></td>
            <td>{{ 'Buyer.Fees' | translate }}</td>
            <td>{{(data.vpihs.fees) | number: '1.2-2'}} {{data.vpihs.currency}}</td>
          </tr>
          <tr>
            <td colspan="3" class="border-0"></td>
            <td>{{ 'Buyer.Donation' | translate }}</td>
            <td>{{(data.vpihs.donation) | number: '1.2-2'}} {{data.vpihs.currency}}</td>
          </tr>
          <tr>
            <td colspan="3" class="border-0"></td>
            <td>{{ 'Buyer.Discount' | translate }}</td>
            <td>{{(data.vpihs.discount) | number: '1.2-2'}} {{data.vpihs.currency}} </td>
          </tr>
          <tr>
            <td colspan="3" class="border-0 fw-bold text-primary"></td>
            <td class="border-0">{{ 'Buyer.Total' | translate }}</td>
            <td class="border-0">{{((data.vpihs.subTotal +
              data.vpihs.taxes +
              data.vpihs.fees +
              data.vpihs.donation +
              data.vpihs.discount) | number: '1.2-2')}} {{data.vpihs.currency}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <button mat-raised-button type="button" matTooltip="Print" (click)="print()" class="me-2">
      <i class="fa fa-print fa-lg"></i>
    </button>
    <button mat-raised-button type="button" matTooltip="Export as PDF" (click)="pdf()">
      <i class="fa fa-file-pdf fa-lg"></i>
    </button>
  </div>
</div>
